module.exports = __webpack_public_path__ + "img/梅-素材.1006dce0.svg";